// extracted by mini-css-extract-plugin
export default {"logo":"NBLogoWhite_logo__gUZPM","logoVisible":"NBLogoWhite_logoVisible__iGgBs"};